import React, { useEffect } from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import Blogs from "./Blogs";

const BlogsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Header />
            <MainComponent type='blogs' />
            <Blogs />
            <Footer />
            <FooterDown />
        </div>
    );
};

export default BlogsPage;
